import { Link } from '../../data/models/Links'

const getPageSize = (size: number, totalPage: number) => {
  if (totalPage === 1) {
    return size
  }
  return size < 10 && size > 0 ? 10 : size
}

const parsePageLinks = (page: any) => {
  const totEle = +page?.totalElements ?? 0
  const totPage = totEle < 11 ? 0 : (+page?.totalPages ?? 0) + 1
  const pageNumber = totEle < 11 ? 0 : page?.number ?? 0
  const pgSize = getPageSize(+page?.size ?? 0, totPage)
  return {
    size: pgSize,
    totalElements: +page?.totalElements ?? 0,
    totalPages: totPage,
    number: pageNumber,
  }
}

const paymentLinksParser = (resp: any) => {
  let errorObj
  if (resp?.error) {
    errorObj = resp?.error
  }

  const pageData = {
    size: resp?.size ?? 10,
    totalElements: resp?.totalLinks ?? 0,
    totalPages: resp?.totalPages ?? 0,
    number: resp?.currentPage ?? 0,
  }
  const pagination = parsePageLinks(pageData)

  const getContent = () => {
    return (
      resp?.links?.map((data: any) =>
        Link.create({
          id: data?.id ?? 'NA',
          jioLinkId: data?.jioLinkId ?? '',
          url: data?.url ?? '',
          // createdAt: dateFormatter(data?.createdAt ?? 'NA', DateFormatTypes.DD_MMM_YYYY_FROM_YYYYMMDD),
          createdAt: data?.createdAt ?? 'NA',
          status: data?.linkStatus ?? '',
          amount: data?.amount ?? '',
          merchantLinkId: data?.merchantLinkId ?? '',
          linkExpiryAt: data?.linkExpiryAt ?? '',
          invoice: data?.invoice ?? '',
          description: data?.description ?? '',
          pushSmsTo: data?.pushSmsTo ?? '',
          pushEmailTo: data?.pushEmailTo ?? '',
          merchantReturnUrl: data?.merchantReturnUrl ?? '',
          merchantCallBackUrl: data?.merchantCallBackUrl ?? '',
          customerName: data?.customerName ?? '',
        }),
      ) ?? []
    )
  }
  return { links: getContent(), page: pagination, error: errorObj }
}
export { paymentLinksParser }
